import React, { useMemo, useRef, useState } from 'react';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { Bold, Eye, Heading2, Italic, List, ListOrdered, Pencil, Quote, Sparkles } from 'lucide-react';
import { Button, IconButton } from './ui.jsx';

const TOOLS = [
  { icon: Heading2, label: '二级标题', prefix: '## ', suffix: '', placeholder: '标题' },
  { icon: Bold, label: '粗体', prefix: '**', suffix: '**', placeholder: '重点内容' },
  { icon: Italic, label: '斜体', prefix: '*', suffix: '*', placeholder: '补充说明' },
  { icon: List, label: '无序列表', prefix: '- ', suffix: '', placeholder: '列表项' },
  { icon: ListOrdered, label: '有序列表', prefix: '1. ', suffix: '', placeholder: '列表项' },
  { icon: Quote, label: '引用', prefix: '> ', suffix: '', placeholder: '引用内容' },
];

export default function MarkdownEditor({ value = '', onChange, onFormat, formatting = false }) {
  const [mode, setMode] = useState('edit');
  const textareaRef = useRef(null);
  const html = useMemo(() => DOMPurify.sanitize(marked.parse(value || '', { breaks: true, gfm: true })), [value]);

  const insert = ({ prefix, suffix, placeholder }) => {
    const textarea = textareaRef.current;
    if (!textarea) return;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selected = value.slice(start, end) || placeholder;
    const needsLineStart = ['## ', '- ', '1. ', '> '].includes(prefix) && start > 0 && value[start - 1] !== '\n';
    const before = needsLineStart ? '\n' : '';
    const next = `${value.slice(0, start)}${before}${prefix}${selected}${suffix}${value.slice(end)}`;
    onChange(next);
    requestAnimationFrame(() => {
      const selectionStart = start + before.length + prefix.length;
      textarea.focus();
      textarea.setSelectionRange(selectionStart, selectionStart + selected.length);
    });
  };

  return (
    <div className="markdown-editor">
      <div className="markdown-toolbar">
        <div className="markdown-tools">
          {TOOLS.map((tool) => <IconButton key={tool.label} icon={tool.icon} label={tool.label} onClick={() => insert(tool)} />)}
        </div>
        <div className="markdown-toolbar-actions">
          {onFormat && <Button size="sm" icon={Sparkles} loading={formatting} onClick={onFormat}>标准化排版</Button>}
          <div className="segmented-control" aria-label="JD 编辑模式">
            <button className={mode === 'edit' ? 'active' : ''} onClick={() => setMode('edit')}><Pencil size={14} />编辑</button>
            <button className={mode === 'preview' ? 'active' : ''} onClick={() => setMode('preview')}><Eye size={14} />预览</button>
          </div>
        </div>
      </div>
      {mode === 'edit'
        ? <textarea ref={textareaRef} rows="15" value={value} onChange={(event) => onChange(event.target.value)} placeholder={'## 岗位职责\n\n- 描述核心职责和预期成果\n\n## 任职要求\n\n- 描述必要经验与能力'} />
        : <div className="markdown-preview">{value.trim() ? <div dangerouslySetInnerHTML={{ __html: html }} /> : <p className="markdown-empty">尚未填写 JD 内容</p>}</div>}
    </div>
  );
}
